import { Box, ButtonBase, Divider, Modal, Stack, Typography } from "@mui/material"
import { useState } from "react"
import FlexBetween from "../components/flexbox/FlexBetween"
import { fCurrency } from "../utils/format"
import FlexRowAlign from "../components/flexbox/FlexRowAlign"

export default function Docs() {
    const [open, setOpen] = useState(false)
    return <>
        <ButtonBase onClick={() => setOpen(true)}>
            <Typography sx={{ color: '#989898' }}>Docs</Typography>
        </ButtonBase>
        <Modal open={open} sx={{ background: "#000" }}>
            <Stack p={2} overflow={'scroll'} height={'100vh'} pb={8}>
                <FlexBetween>
                    <Typography fontWeight={500} sx={{ color: '#89ec5d' }}>#Codium</Typography>
                    <Typography fontWeight={500} sx={{ color: '#89ec5d' }}>v1.0.21</Typography>
                </FlexBetween>
                <Typography fontWeight={500} sx={{ color: '#89ec5d' }}>## /Token/info</Typography>
                <FlexBetween gap={2}>
                    <Typography sx={{ color: '#8AEB5D' }}>[token_name]</Typography>
                    <Typography sx={{ color: '#B1B1B1' }}>COM</Typography>
                    <Box flexGrow={1} />
                </FlexBetween>
                <FlexBetween gap={2} >
                    <Typography sx={{ color: '#8AEB5D' }}>[token_supply]</Typography>
                    <Typography sx={{ color: '#B1B1B1' }}>{fCurrency(1000000000)}</Typography>
                    <Box flexGrow={1} />
                </FlexBetween>
                <Divider sx={{ borderTop: "1px dashed #8AEB5D !important", borderColor: 'transparent', my: 1 }} />
                <Typography mb={1} fontWeight={500} sx={{ color: '#89ec5d' }}>## /What_Is_Codium</Typography>
                <Typography fontWeight={700}>Codium: Powering AI Training Through Decentralized Data Sharing</Typography>
                <Typography >Codium is a dePIN project built on Telegram Mini-Apps that lets users contribute their data for AI training while earning rewards. It transforms token distribution by rewarding participants for sharing their Internet bandwidth. The faster your connection, the more tokens you can mine, creating a competitive and engaging mining experience.</Typography>
                <Typography >As AI Agents continue to evolve, Codium is positioning itself to power the next generation of AI swarms. These agents will collaborate, interact, and drive revenue within the ecosystem. The autonomous economy isn’t a distant future—it’s happening now. Early contributors to Codium will play a key role in shaping this transformation and stand to benefit the most.</Typography>
                <Divider sx={{ borderTop: "1px dashed #8AEB5D !important", borderColor: 'transparent', my: 1 }} />

                <Typography mb={1} fontWeight={500} sx={{ color: '#89ec5d' }}>## /How_It_Work</Typography>
                <Typography>Connect as a node operator and share your excess bandwidth to support AI training. Your node helps power our decentralized network, and in return, you earn $COM tokens every 30 seconds. Rewards are based on your bandwidth speed, contribution quality, and consistency, turning your idle resources into valuable assets. It’s a simple way to put your unused bandwidth to work and get rewarded.</Typography>
                <Divider sx={{ borderTop: "1px dashed #8AEB5D !important", borderColor: 'transparent', my: 1 }} />

                <Typography mb={1} fontWeight={500} sx={{ color: '#89ec5d' }}>## /Power_Mechanism</Typography>
                <Typography>Codium Power Mechanism:</Typography>
                <FlexBetween gap={2} >
                    <Typography sx={{ color: '#8AEB5D' }}>Initial:</Typography>
                    <Typography sx={{ color: '#B1B1B1' }}>Max Of {fCurrency(5000)} Power</Typography>
                    <Box flexGrow={1} />
                </FlexBetween>
                <FlexBetween gap={2} >
                    <Typography sx={{ color: '#8AEB5D' }}>Usage:</Typography>
                    <Typography sx={{ color: '#B1B1B1' }}>{fCurrency(1000)} Power per 60s of sharing</Typography>
                    <Box flexGrow={1} />
                </FlexBetween>
                <FlexBetween gap={2} >
                    <Typography sx={{ color: '#8AEB5D' }}>Recovery:</Typography>
                    <Typography sx={{ color: '#B1B1B1' }}>15 Power every 60s</Typography>
                    <Box flexGrow={1} />
                </FlexBetween>
                <Typography><span style={{ color: '#8AEB5D' }}>**</span> Power ensures network stability and rewards active contributors.</Typography>
                <Divider sx={{ borderTop: "1px dashed #8AEB5D !important", borderColor: 'transparent', my: 1 }} />

                <Typography mb={1} fontWeight={500} sx={{ color: '#89ec5d' }}>## /Earning_System</Typography>
                <Typography>Total Supply: 1,000,000,000 $COM</Typography>
                <Typography>Distribution: 30-second intervals</Typography>
                <Typography sx={{ color: '#8AEB5D' }}>Earn Rate: Based on Node mode</Typography>
                <Typography>Standard: 0,00058 $COM/30s</Typography>
                <Typography>Super Mode: 0,0029 $COM/30s</Typography>
                <Typography>Prime Mode: 0,0087 $COM/30s</Typography>
                <Typography>Deluxe Mode: 0,0174 $COM/30s</Typography>
                <Typography>Ultimate Mode: 0,0232 $COM/30s</Typography>
                <Typography>Mining Ends: April 2025 or when supply depleted</Typography>

                <Typography><span style={{ color: '#8AEB5D' }}>//</span> A fair system designed for everyone, no exceptions ⚖️</Typography>
                <Divider sx={{ borderTop: "1px dashed #8AEB5D !important", borderColor: 'transparent', my: 1 }} />
                <Typography mb={1} fontWeight={500} sx={{ color: '#89ec5d' }}>#/When_The_Target_Token_Supply_Is_Mined</Typography>
                <Typography>Upon reaching the target token supply, all minted tokens will be distributed to participants as Jettons on the TON blockchain</Typography>
                <Divider sx={{ borderTop: "1px dashed #8AEB5D !important", borderColor: 'transparent', my: 1 }} />
                <Typography mb={1} fontWeight={500} sx={{ color: '#89ec5d' }}>#/Tokenomics</Typography>
                <Stack spacing={1}>
                    <FlexBetween gap={2}>
                        <Typography sx={{ color: '#8AEB5D', minWidth: 100 }}>Team & VCs</Typography>
                        <img src="/images-asset/Team.png" style={{ height: '15px' }} />
                        <Typography sx={{ width: '100%', color: '#8AEB5D' }}>{fCurrency(5, 2)}%</Typography>
                    </FlexBetween>
                    <FlexBetween gap={2}>
                        <Typography sx={{ color: '#8AEB5D', minWidth: 100 }}>Liquidity</Typography>
                        <img src="/images-asset/Liquidity.png" style={{ height: '15px' }} />
                        <Typography sx={{ width: '100%', color: '#8AEB5D' }}>{fCurrency(10, 2)}%</Typography>
                    </FlexBetween>
                    <FlexBetween gap={2}>
                        <Typography sx={{ color: '#8AEB5D', minWidth: 100 }}>Miners</Typography>
                        <img src="/images-asset/Miners.png" style={{ height: '15px' }} />
                        <Typography sx={{ width: '100%', color: '#8AEB5D' }}>{fCurrency(80, 2)}%</Typography>
                    </FlexBetween>
                    <FlexBetween gap={2}>
                        <Typography sx={{ color: '#8AEB5D', minWidth: 100 }}>Airdrop</Typography>
                        <img src="/images-asset/Airdrop.png" style={{ height: '15px' }} />
                        <Typography sx={{ width: '100%', color: '#8AEB5D' }}>{fCurrency(5, 2)}%</Typography>
                    </FlexBetween>
                </Stack>
                <ButtonBase onClick={() => setOpen(false)} sx={{ position: 'absolute', bottom: '10px', left: '50%', translate: '-50% 0px', background: '#fff', color: "#000", fontSize: '1.1rem', width: '90%', lineHeight: '30px', fontWeight: 500 }}>
                    Close
                </ButtonBase>
            </Stack>
        </Modal>
    </>
}